<script lang="ts">
  import type { ProfileMergeList } from '$provider/models/CaqhMergeList';
  import Review from './Review.svelte';
  import Toggle from './Toggle.svelte';
  import Label from '$provider/constants/Label';
  import Spinner from '$shared/atoms/Spinner/Spinner.svelte';

  interface Props {
    item: ProfileMergeList;
    onreview?: (item: ProfileMergeList) => void;
    ontoggleadd?: (item: ProfileMergeList) => void;
  }

  let { item = $bindable(), onreview, ontoggleadd }: Props = $props();

  const onToggleChange = (e: any): void => {
    item.props.checked = e.target.checked;
    ontoggleadd?.(item);
  };

  const onClickReviewAction = (): void => {
    onreview?.(item);
  };
</script>

{#if item}
  <div class="caqh-merge-overview-action" data-cy="item-action">
    {#if item.loading}
      <Spinner />
    {:else if item.isMerge}
      <Review {item} onclick={onClickReviewAction} />
    {:else if item.isAdd}
      <Toggle {item} onchange={onToggleChange} />
    {:else}
      <div class="invalid" data-cy="unknown-merge-type">{Label.UnknownMergeType}</div>
    {/if}
  </div>
{/if}
